<template>
    <n-config-provider
        :locale="zhCN"
        :date-locale="dateZhCN"
        :theme-overrides="lightThemeOverrides"
    >
        <slot />
    </n-config-provider>
</template>

<script setup>
import { zhCN, dateZhCN } from 'naive-ui'
import { computed } from 'vue'
const addLight = (color, amount) => {
    const cc = parseInt(color, 16) + amount
    const c = cc > 255 ? 255 : cc
    return c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
}
const lighten = (color, amount) => {
    color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color
    amount = Math.trunc((255 * amount) / 100)
    return `#${addLight(color.substring(0, 2), amount)}${addLight(
        color.substring(2, 4),
        amount,
    )}${addLight(color.substring(4, 6), amount)}`
}
const appThemeColor = '#12A3E8'
const lightenStr = lighten(appThemeColor, 6)
const lightThemeOverrides = computed(() => ({
    common: {
        primaryColor: appThemeColor,
        primaryColorHover: lightenStr,
        successColor: appThemeColor,
    },
    LoadingBar: { colorLoading: appThemeColor },
}))
</script>
